/**
 * Pure element-wheel resolution (rule.md §6.2, §8). Side-effect free.
 */
import { BEATS, type Element } from "../types/element";

export type ElementOutcome = "win" | "lose" | "draw";

/**
 * Resolve the attacker's element against the defender's on the 5-element wheel.
 * - "win"  → attacker beats defender (defender takes the hit)
 * - "lose" → attacker is beaten (attacker takes the hit)
 * - "draw" → same element → standoff (no damage, rule.md §7.2)
 */
export function elementOutcome(
  attacker: Element,
  defender: Element,
): ElementOutcome {
  if (attacker === defender) return "draw";
  return BEATS[attacker].includes(defender) ? "win" : "lose";
}
